import axios from 'axios';

/**
 * 타임아웃 15초.
 *
 * 예전에는 5초였다. 사무실 와이파이에서는 충분하지만 이 앱은 모바일에서 쓰인다 —
 * 지하철·엘리베이터·건물 안쪽처럼 신호가 약한 곳에서는 정상 요청도 5초를 넘긴다.
 * 그러면 서버는 요청을 처리했는데 앱만 실패로 처리하는 일이 생긴다(예약 접수가 대표적).
 * 게다가 대부분의 화면이 실패를 화면에 알리지 않아, 사용자에게는 '버튼이 안 먹는' 것으로만 보였다.
 *
 * 특정 호출만 다르게 하고 싶으면 호출부에서 `{ timeout: 30000 }` 으로 덮어쓸 수 있다.
 */
const instance = axios.create({
    baseURL: (process.env.REACT_APP_API_URL || ''),
    timeout: 15000
});

// 요청 인터셉터
instance.interceptors.request.use(function (config:any) {
    const token = window.localStorage.getItem('token');
    const userID = window.localStorage.getItem('userID');
    try {
        if (token) {
            config.headers["token"] = token;
            config.headers["userId"] = userID;
        }
        return config;
    } catch (err:any) {
        console.error("[_axios.interceptors.request] config : " + err.message);
    }
    
    return config;
}, function (error:any) {
    // 요청 오류 처리
    return Promise.reject(error);
});

// 응답 인터셉터
instance.interceptors.response.use(async function (response:any) {
    return response;
}, async function (error:any) {
    // 오류를 가공하지 않고 그대로 흘려보낸다.
    // 기존 코드는 `const {response: {status}} = error` 로 구조분해했는데,
    // 타임아웃(ECONNABORTED)·네트워크 단절·CORS 차단처럼 response 가 없는 오류에서는
    // 이 줄 자체가 TypeError 를 던져서 호출부 catch 에 도착하는 오류가
    // 실제 원인이 아닌 "Cannot destructure property 'status' of ..." 로 바뀌었다.
    // 상태 코드가 필요하면 error?.response?.status 로 안전하게 읽을 것.

    /*if (error?.response?.status === 401) {   // empty token
        window.localStorage.clear();
        alert("세션이 만료되었습니다. 로그인 후 이용해주세요.");
        location.href = "/login";
    }*/

/*    const sendItems = new Object();
    sendItems.token = window.localStorage.getItem('token');
    const isOkTokenResult = await instance.post('/isOk', sendItems);
    if (isOkTokenResult.data != "Success") {
        window.localStorage.clear();
        alert("로그인 정보가 변경되어 로그아웃 되었습니다.");
        location.href = "/login";
    }*/

    return Promise.reject(error);
});

export default instance;